export default "__VITE_ASSET__3gQfhb$P__"